import React, { createContext, useContext, useState, useCallback } from 'react';

interface ThemeContextType {
  mode: 'dark';
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType>({
  mode: 'dark',
  toggleTheme: () => {},
});

export const useThemeContext = () => useContext(ThemeContext);

export const ThemeContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Single dark mode only
  const [mode] = useState<'dark'>('dark');
  const toggleTheme = useCallback(() => {}, []);

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export { ThemeContext }; 